import React from "react";

const Logo = () => {
    return (
        <div className="logo">
            <img src="../images/logo-couleur.svg" alt="logo"/>
        </div>
    )
}

export default Logo;